<template>
  <span class="avatar" :style="style" :title="name">
    <img v-if="image && !broken" :src="image" alt="" @error="broken = true" />
    <img v-else-if="anonymous" src="@/assets/img/anon.jpeg" alt="" />
    <span v-else>{{ initials }}</span>
  </span>
</template>

<script>
// Someone's picture, or their initials on a colour that is always theirs.
const PALETTE = ["#8f27b2", "#7357e7", "#0e7490", "#0f766e", "#b45309", "#be123c", "#4338ca", "#15803d"];

export function colourOf(name) {
  let h = 0;
  for (const c of name || "?") h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export default {
  name: "Avatar",
  props: {
    name: { type: String, default: "" },
    image: { type: String, default: "" },
    size: { type: Number, default: 36 },
    anonymous: { type: Boolean, default: false },
  },
  data() {
    return { broken: false };
  },
  computed: {
    initials() {
      const words = (this.name || "?").trim().split(/\s+/);
      return words
        .slice(0, 2)
        .map((w) => w[0] || "")
        .join("")
        .toUpperCase();
    },
    style() {
      return {
        width: this.size + "px",
        height: this.size + "px",
        fontSize: Math.round(this.size * 0.4) + "px",
        background: colourOf(this.name),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.02em;
  user-select: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
